<template>
  <div class="px-3 pb-2">
    <h4>{{ count.toLocaleString() }} éléments</h4>
    <address-search
      v-if="!config.hideSearchBar"
      class="mb-4"
    />
    <v-row v-if="dataset">
      <v-col
        v-for="(filter, i) in config.dynamicFilters"
        :key="i"
        :cols="12"
        :sm="6"
        :md="12"
        class="py-0"
      >
        <v-select
          v-if="enums && filter.facet"
          v-model="filters[filter.field.key]"
          :dense="windowWidth <960"
          :label="label(filter.field.key)"
          :items="enums[filter.field.key]"
          multiple
          clearable
          @input="refresh()"
        />
        <v-autocomplete
          v-else
          v-model="filters[filter.field.key]"
          :dense="windowWidth <960"
          :loading="filterLoading"
          :label="label(filter.field.key)"
          :items="values[filter.field.key] || []"
          :filter="() => true"
          placeholder="Saisissez une valeur"
          hide-no-data
          multiple
          clearable
          @update:search-input="getValues(filter.field.key, $event)"
          @input="refresh()"
        >
          <template v-slot:item="data">
            <v-list-item-content v-html="filteredText(data.item, data.parent.searchInput)" />
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import axios from 'axios'
  import eventBus from '../../assets/event-bus.js'
  import { filters2qs } from '@data-fair/components-app/filters/filters'
  import AddressSearch from './Address.vue'

  export default {
    components: { AddressSearch },
    props: {
      dense: { type: Boolean, default: false },
    },
    data: () => ({
      filters: {},
      values: {},
      enums: null,
      filterLoading: false,
      count: 0,
    }),
    computed: {
      ...mapState(['dataset']),
      ...mapGetters(['config', 'datasetUrl']),
      fields () {
        return this.dataset.schema.reduce((a, b) => { a[b.key] = b; return a }, {})
      },
      query () {
        var ret = ''
        var qs = Object.keys(this.filters).filter(field => this.filters[field].length).map(field => `(${this.filters[field].map(f => `${field}:"${f}"`).join(' OR ')})`).join(' AND ')
        if (this.config.filters && this.config.filters.length) {
          qs += (qs.length ? ' AND ' : '') + filters2qs(this.config.filters)
        }
        if (qs.length) ret += '&qs=' + qs
        return ret
      },
    },
    watch: {
      dataset () {
        this.getEnums()
      },
    },
    async mounted () {
      const params = new URLSearchParams(window.location.search)
      this.filters = Object.assign({}, ...this.config.dynamicFilters.map(filter => ({ [filter.field.key]: params.get(filter.field.key) ? JSON.parse(`[${params.get(filter.field.key)}]`) : [] })))
      this.refresh()
      if (this.dataset) await this.getEnums()
    },
    methods: {
      async getEnums () {
        if (!this.dataset || this.enums) return
        const facets = this.config.dynamicFilters.filter(filter => filter.facet)
        this.enums = Object.assign({}, ...facets.map(filter => ({ [filter.field.key]: this.fields[filter.field.key].enum || [] }),
        ))
        const qs = this.config.filters && this.config.filters.length && filters2qs(this.config.filters)
        for (const filter of facets) {
          const params = { field: filter.field.key, agg_size: 1000 }
          if (filter.sort === 'Alphabétique') params.sort = filter.field.key
          if (qs) params.qs = qs
          const results = (await axios.get(this.datasetUrl + '/values_agg', { params })).data
          const labels = this.fields[filter.field.key]['x-labels']
          this.enums[filter.field.key] = results.aggs.map(a => ({ text: `${labels ? labels[a.value] : a.value} (${a.total})`, value: a.value }))
          if (filter.sort === 'Alphabétique') this.enums[filter.field.key].sort((a, b) => a.text.toLowerCase().localeCompare(b.text.toLowerCase()))
        }
      },
      async refresh () {
        eventBus.$emit('query', this.query)
        const params = new URLSearchParams(window.location.search)
        Object.keys(this.filters).forEach(k => {
          if (this.filters[k].length) params.set(k, JSON.stringify(this.filters[k]).slice(1, -1))
          else params.delete(k)
        })
        window.history.replaceState(null, null, window.location.pathname + '?' + params.toString())
        this.count = (await axios.get(`${this.datasetUrl}/lines?size=0${this.query}`)).data.total
      },
      label (key) {
        const field = this.dataset.schema.find(f => f.key === key)
        return field.title || field['x-originalName'] || field.key
      },
      async getValues (field, q) {
        this.filterLoading = true
        if (!q || q.length > 2) this.$set(this.values, field, (await axios.get(this.datasetUrl + '/values/' + field, { params: { q, q_mode: 'complete' } })).data)
        this.filterLoading = false
      },
      filteredText (item, search) {
        if (!search) return item
        const nItem = item.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
        const nSearch = search.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
        const idx = nItem.indexOf(nSearch)
        if (idx < 0) return item
        const start = item.slice(0, idx)
        const middle = item.slice(idx, idx + search.length)
        const end = item.slice(idx + search.length)
        return `<div>${start}<span class="v-list-item__mask">${middle}</span>${end}</div>`
      },
    },
  }
</script>
